/**
 * 🧤 GLOVES
 *
 * Hand armor equipment items (10 total)
 * Level requirements: 10-80 (increments of ~10)
 * Stat requirements: STR for gauntlets, DEX for light gloves
 *
 * Level Distribution:
 * - Common (2): Lv 10, 15
 * - Uncommon (2): Lv 25, 30
 * - Rare (2): Lv 40, 45
 * - Epic (2): Lv 55, 60
 * - Legendary (2): Lv 75, 85
 */

export const GLOVES = {
  // ============================================================
  // COMMON GLOVES (2) - Lv 10, 15
  // ============================================================
  clothGloves: {
    id: 'clothGloves',
    name: 'Cloth Gloves',
    icon: '🧤',
    slot: 'gloves',
    rarity: 'common',
    levelReq: 10,
    requirements: { DEX: 8 },
    description: 'Simple cloth gloves for basic hand protection.',
    stats: {
      attack: 1,
      critChance: 0.01,
    },
  },
  leatherGloves: {
    id: 'leatherGloves',
    name: 'Leather Gloves',
    icon: '🧤',
    slot: 'gloves',
    rarity: 'common',
    levelReq: 15,
    requirements: { STR: 15 },
    description: 'Sturdy leather gloves with a good grip.',
    stats: {
      attack: 2,
      critChance: 0.02,
    },
  },

  // ============================================================
  // UNCOMMON GLOVES (2) - Lv 25, 30
  // ============================================================
  chainGauntlets: {
    id: 'chainGauntlets',
    name: 'Chain Gauntlets',
    icon: '🥊',
    slot: 'gloves',
    rarity: 'uncommon',
    levelReq: 25,
    requirements: { STR: 40 },
    description: 'Metal gauntlets with chainmail backing.',
    stats: {
      attack: 3,
      critChance: 0.04,
      defense: 1,
    },
  },
  studdedGloves: {
    id: 'studdedGloves',
    name: 'Studded Gloves',
    icon: '🧤',
    slot: 'gloves',
    rarity: 'uncommon',
    levelReq: 30,
    requirements: { STR: 35, DEX: 20 },
    description: 'Leather gloves with metal studs for extra punch.',
    stats: {
      attack: 4,
      critChance: 0.03,
    },
  },

  // ============================================================
  // RARE GLOVES (2) - Lv 40, 45
  // ============================================================
  plateGauntlets: {
    id: 'plateGauntlets',
    name: 'Plate Gauntlets',
    icon: '🥊',
    slot: 'gloves',
    rarity: 'rare',
    levelReq: 40,
    requirements: { STR: 75 },
    description: 'Heavy plate gauntlets for crushing blows.',
    stats: {
      attack: 6,
      critChance: 0.06,
      defense: 3,
    },
  },
  dragonClaws: {
    id: 'dragonClaws',
    name: 'Dragon Claws',
    icon: '🐉',
    slot: 'gloves',
    rarity: 'rare',
    levelReq: 45,
    requirements: { STR: 60, DEX: 40 },
    description: 'Gauntlets tipped with actual dragon claws.',
    stats: {
      attack: 7,
      critChance: 0.08,
      critDamage: 0.15,
    },
  },

  // ============================================================
  // EPIC GLOVES (2) - Lv 55, 60
  // ============================================================
  titanGauntlets: {
    id: 'titanGauntlets',
    name: 'Titan Gauntlets',
    icon: '⚜️',
    slot: 'gloves',
    rarity: 'epic',
    levelReq: 55,
    requirements: { STR: 115 },
    description: 'Massive gauntlets that crush anything they grip.',
    stats: {
      attack: 10,
      critChance: 0.10,
      defense: 6,
    },
  },
  voidGrips: {
    id: 'voidGrips',
    name: 'Void Grips',
    icon: '🌑',
    slot: 'gloves',
    rarity: 'epic',
    levelReq: 60,
    requirements: { STR: 90, INT: 50 },
    description: 'Gauntlets that channel void energy into each strike.',
    stats: {
      attack: 12,
      critChance: 0.12,
      critDamage: 0.25,
    },
  },

  // ============================================================
  // LEGENDARY GLOVES (2) - Lv 75, 85
  // ============================================================
  infinityGrasp: {
    id: 'infinityGrasp',
    name: 'Infinity Grasp',
    icon: '✨',
    slot: 'gloves',
    rarity: 'legendary',
    levelReq: 75,
    requirements: { STR: 150, DEX: 50 },
    description: 'Gauntlets that hold the power of infinity.',
    stats: {
      attack: 16,
      critChance: 0.15,
      critDamage: 0.40,
      defense: 8,
    },
  },
  cosmicClaws: {
    id: 'cosmicClaws',
    name: 'Cosmic Claws',
    icon: '🌌',
    slot: 'gloves',
    rarity: 'legendary',
    levelReq: 85,
    requirements: { STR: 140, DEX: 80 },
    description: 'Claws forged from the essence of dying stars.',
    stats: {
      attack: 18,
      critChance: 0.18,
      critDamage: 0.50,
    },
  },
};
